import { FUEL_GOAL } from "./data";
import { Ship } from "./ShipViz";

export const ShipHud = ({ total, boost = false }) => {
  const progress = Math.min(total / FUEL_GOAL, 1);
  const pct = Math.round(progress * 100);
  const km = Math.round(384400 * (1 - progress));

  return (
    <section
      id="mission"
      data-testid="mission-hud"
      data-boost={boost ? "true" : "false"}
      className="corner-tick relative mx-auto w-full max-w-6xl overflow-hidden border-y border-[#1c2740] bg-[#050810] px-4 sm:px-6"
      style={{ height: "104px" }}
      aria-label="Ship telemetry HUD"
    >
      <div className="stars pointer-events-none" />
      <div className="stars2 pointer-events-none" />
      <div className="stars3 pointer-events-none" />
      {boost && <div className="burst-flash absolute inset-0 z-10" />}

      <div
        data-testid="ship-visualization"
        className="relative flex h-full items-center gap-3 sm:gap-5"
      >
        {/* left readouts */}
        <div className="mono z-20 hidden shrink-0 flex-col text-[9px] tracking-[0.25em] text-slate-500 sm:flex">
          <span className="flex items-center gap-1.5">
            <span className={`h-1.5 w-1.5 rounded-full ${boost ? "bg-gmh-orange blink-fast" : "bg-gmh-cyan blink"}`} />
            TELEMETRY <span className="text-gmh-cyan">{"//"}</span> SAM-01
          </span>
          <span className="mt-1">DIST TO HOME</span>
          <span className="text-slate-200">{km.toLocaleString()} KM</span>
        </div>

        {/* trajectory */}
        <div className="relative h-8 min-w-0 flex-1">
          <div className="absolute left-0 right-6 top-1/2 border-t border-dashed border-[#22304f]" />
          <div
            className="absolute left-0 top-1/2 h-px bg-gradient-to-r from-gmh-orange/70 to-gmh-cyan/70 shadow-[0_0_8px_rgba(53,224,240,0.5)] transition-all duration-[1600ms]"
            style={{ width: `calc(${progress * 100}% * 0.92)`, transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}
          />

          {/* ship at progress */}
          <div
            className="ship-track absolute top-1/2 z-20 -translate-y-1/2"
            style={{ left: `calc(${progress} * 88%)` }}
          >
            <div className="ship-bob relative scale-[0.55] origin-left">
              <Ship />
            </div>
          </div>

          {/* tiny Earth at right end */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <div className="earth-ring absolute inset-0 rounded-full border border-gmh-cyan/40" />
            <div className="earth h-6 w-6" />
          </div>
        </div>

        {/* right readout */}
        <div className="mono z-20 shrink-0 text-right">
          <div className="text-lg font-bold leading-none text-white sm:text-xl">
            <span data-testid="fuel-progress-percent" className={boost ? "value-pop" : ""}>{pct}%</span>
            <span className="ml-1 text-[9px] font-normal tracking-[0.25em] text-slate-500">HOME</span>
          </div>
          <div className="mt-1 hidden text-[9px] tracking-[0.25em] text-slate-500 sm:block">
            FUEL ${(total).toLocaleString()} / $10,000
          </div>
        </div>
      </div>
    </section>
  );
};
